// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import DropDownSideBarTemplate from '@front/templates/DropDownSideBarTemplate.html';
import { AlertSideBarController } from '@shared/commons/SideBarController/AlertSideBarController';
import { Resources } from '@shared/localizations/Resources';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { ContainerControl } from '../ContainerControl';
export class DropDownSideBar extends ContainerControl {
    constructor() {
        super();
        // this.setFocus();
    }
    getType() {
        return 'DropDownSideBar';
    }
    oninit() {
        super.oninit();
        super.on('onCloseClick', this.hide);
        super.on('onUpdateHeader', this.localizeHeader);
        super.observe('activeSidePanel', this.changePanel);
    }
    changePanel() {
        this.setVisibleActivePanel();
        this.localizeHeader();
    }
    hide() {
        DropDownSideBar.ClosePanel.Raise();
    }
    setVisibleActivePanel() {
        const activeSide = super.get('activeSidePanel');
        const whichPanel = {
            Alert: false,
            Notifications: false,
            VideoWidget: false
        };
        switch (activeSide) {
            case PanelNames.AlertPanel:
                whichPanel.Alert = true;
                break;
            case PanelNames.NotificationsPanel:
                whichPanel.Notifications = true;
                break;
            case PanelNames.VideoWidget:
                whichPanel.VideoWidget = true;
                break;
        }
        void this.set({ whichPanel });
    }
    localizeHeader() {
        const activeSide = super.get('activeSidePanel');
        switch (activeSide) {
            case PanelNames.AlertPanel:
                void super.set({
                    headerLocalText: Resources.getResource('screen.Alerts') + ('  (' + AlertSideBarController.getCountAlerts() + ')')
                });
                break;
            case PanelNames.NotificationsPanel:
                void super.set('headerLocalText', Resources.getResource('panel.Notifications'));
                break;
            case PanelNames.VideoWidget:
                void super.set('headerLocalText', Resources.getResource('panel.VideoWidget'));
                break;
        }
    }
    onMouseDown(event) {
        var _a;
        (_a = this.get('SideBarPanelRef')) === null || _a === void 0 ? void 0 : _a.onMouseDown(event, false);
        super.onMouseDown(event, false);
    }
}
DropDownSideBar.ClosePanel = new CustomEvent();
ContainerControl.extendWith(DropDownSideBar, {
    template: DropDownSideBarTemplate,
    data: function () {
        return {
            activeSidePanel: null,
            headerLocalText: '',
            SideBarPanelRef: null
        };
    }
});
